import React, { useState } from "react"
import { IFileProvider } from "../../../../api/fileProvider/IFileProvider";
import { IAnalysisFolder } from "./IAnalysisFolder";
import "./FullAnalysisAddFolderPanel.css";
import { useAppContext } from '../../../../appContext';
import { IFullAnalysisFileRecord } from "./FullAnalysisTypes";

interface IFullAnalysisAddFolderPanelProps{
    onAdd: ()=>void;
    onAddFile?: ()=>void;
}

export const FullAnalysisAddFolderPanel = ({onAdd, onAddFile}:IFullAnalysisAddFolderPanelProps)=>{
    const { translate } = useAppContext();

    const handleAddFolder = ()=>{
        onAdd();
    }

    const handleAddFile = ()=>{
        onAddFile?.();
    }

    return <div className="FullAnalysisAddFolderPanel">
        <div className="button FullAnalysisAddFolderPanel_button" onClick={handleAddFolder}>
            <div className="FullAnalysisAddFolderPanel_button_icon">

            </div>
            <div className="FullAnalysisAddFolderPanel_button_text">
                {translate('analysis_create_new_folder')}
            </div>
        </div>
        {onAddFile && <div className="button FullAnalysisAddFolderPanel_button" onClick={handleAddFile}>
            <div className="FullAnalysisAddFolderPanel_button_icon">

            </div>
            <div className="FullAnalysisAddFolderPanel_button_text">
                {translate('analysis_add_file')}
            </div>
        </div>}
    </div>
}

export const FullAnalysisAddFolderPanelNew = ({provider, selectedItem}: {provider: IFileProvider, selectedItem: IAnalysisFolder})=>{
    const { translate } = useAppContext();
    const currentFolder = provider?.crumbs[provider.crumbs.length-1];
    const [showAnalysisInput, setShowAnalysisInput] = useState(false);
    const [analysisText, setAnalysisText] = useState('');
    const [fileName, setFileName] = useState('');

    const handleAddFolder = ()=>{
        console.log('create folder');
        const newFolder: IAnalysisFolder = {
            name: "test_folder",
            iconIndex: 0,
            date: new Date(),
            type: "folder"
        }
        provider.createFolder(newFolder, currentFolder?.id);
    }

    const handleAddFile = ()=>{
        setShowAnalysisInput(true);
        setFileName('');
        setAnalysisText('');
    }

    const handleCreateAnalysisFile = ()=>{
        if (!analysisText.trim() || !fileName.trim()) {
            alert(translate('analysis_error_empty'));
            return;
        }

        const analysisRecord: IFullAnalysisFileRecord = {
            name: fileName,
            tags: [],
            date: new Date().toISOString(),
            action: 'analysis',
            relatedClientId: '', // You may want to set this based on current client
            chunks: [{
                type: 'notes',
                data: {
                    iconUrl: '',
                    title: analysisText.substring(0, 50) + (analysisText.length > 50 ? '...' : ''),
                    date: new Date().toISOString()
                }
            }]
        };

        const newFile: IAnalysisFolder = {
            fileData: [analysisRecord],
            name: fileName.endsWith('.analysis') ? fileName : fileName + '.analysis',
            iconIndex: 0,
            date: new Date(),
            mimeType: 'text/analysis',
            type: 'file'
        };

        provider.createFolder(
            newFile,
            selectedItem?.type == 'folder' ? selectedItem.id : currentFolder.id
        );
        setShowAnalysisInput(false);
        setAnalysisText('');
        setFileName('');
    }

    const handleAppendToFile = (file: IAnalysisFolder)=>{
        if (!analysisText.trim()) {
            alert(translate('analysis_error_content'));
            return;
        }

        const analysisRecord: IFullAnalysisFileRecord = {
            name: file.name,
            tags: [],
            date: new Date().toISOString(),
            action: 'analysis_append',
            relatedClientId: '', // You may want to set this based on current client
            chunks: [{
                type: 'notes',
                data: {
                    iconUrl: '',
                    title: analysisText.substring(0, 50) + (analysisText.length > 50 ? '...' : ''),
                    date: new Date().toISOString()
                }
            }]
        };

        const updatedFile: IAnalysisFolder = {
            ...file,
            fileData: [...(file.fileData || []), analysisRecord]
        };

        provider.updateFile(updatedFile);
        setShowAnalysisInput(false);
        setAnalysisText('');
    }

    const existingAnalysisFiles = currentFolder?.folderItems?.filter(item => 
        item.type === 'file' && (item.name.endsWith('.analysis') || item.mimeType === 'text/analysis')
    ) || [];

    return <div className="FullAnalysisAddFolderPanel">
        <div className="button FullAnalysisAddFolderPanel_button" onClick={handleAddFolder}>
            <div className="FullAnalysisAddFolderPanel_button_icon">

            </div>
            <div className="FullAnalysisAddFolderPanel_button_text">
                {translate('analysis_create_new_folder')}
            </div>
        </div>
        <div className="button FullAnalysisAddFolderPanel_button" onClick={handleAddFile}>
            <div className="FullAnalysisAddFolderPanel_button_icon">

            </div>
            <div className="FullAnalysisAddFolderPanel_button_text">
                {translate('analysis_add_file')}
            </div>
        </div>
        
        {showAnalysisInput && (
            <div className="FullAnalysisAddFolderPanel_input" style={{marginTop: '15px', padding: '15px', border: '1px solid #ccc', borderRadius: '5px'}}>
                <div style={{marginBottom: '10px'}}>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>{translate('analysis_file_name')}</label>
                    <input 
                        type="text" 
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                        placeholder={translate('analysis_file_placeholder')}
                        style={{width: '100%', padding: '8px', borderRadius: '3px', border: '1px solid #ddd'}}
                    />
                </div>
                <div style={{marginBottom: '10px'}}>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>{translate('analysis_content')}</label>
                    <textarea 
                        value={analysisText}
                        onChange={(e) => setAnalysisText(e.target.value)}
                        placeholder={translate('analysis_content_placeholder')}
                        rows={6}
                        style={{width: '100%', padding: '8px', borderRadius: '3px', border: '1px solid #ddd', resize: 'vertical'}}
                    />
                </div>
                <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                    <button 
                        onClick={handleCreateAnalysisFile}
                        style={{padding: '8px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer'}}
                    >
                        {translate('analysis_create_file')}
                    </button>
                    
                    {existingAnalysisFiles.length > 0 && (
                        <div style={{display: 'flex', gap: '5px', flexWrap: 'wrap'}}>
                            {existingAnalysisFiles.map(file => (
                                <button 
                                    key={file.id}
                                    onClick={() => handleAppendToFile(file)}
                                    style={{padding: '8px 10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '12px'}}
                                >
                                    {translate('analysis_append_to')} {file.name}
                                </button>
                            ))}
                        </div>
                    )}
                    
                    <button 
                        onClick={() => setShowAnalysisInput(false)}
                        style={{padding: '8px 15px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer'}}
                    >
                        {translate('common_cancel')}
                    </button>
                </div>
            </div>
        )}
    </div>
}